import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { AlertTriangle, Globe } from 'lucide-react';

const DisclaimerPage = () => {
  const [language, setLanguage] = useState('en');

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-babyblue-50 via-babyblue-100/50 to-white" data-testid="disclaimer-page">
      <Navbar />

      <main className="flex-1 py-12 px-6">
        <div className="container mx-auto max-w-3xl">
          <div className="text-center mb-8">
            <div className="inline-flex items-center gap-2 bg-amber-100 text-amber-800 px-4 py-2 rounded-full text-sm font-medium mb-4">
              <AlertTriangle className="w-4 h-4" />
              {language === 'de' ? 'Wichtiger Hinweis' : 'Important Notice'}
            </div>
            <h1 className="font-heading text-4xl font-bold text-babyblue-900 mb-2">
              Haftungsausschluss <span className="text-babyblue-500 font-normal">/ Disclaimer</span>
            </h1>
            <p className="text-sm text-babyblue-500 mt-1">
              {language === 'de' ? 'Stand: 2026' : 'Last updated: 2026'}
            </p>

            {/* Language Toggle */}
            <div className="flex items-center justify-center gap-3 mt-6">
              <Globe className="w-5 h-5 text-babyblue-500" />
              <div className="flex bg-babyblue-100 rounded-full p-1">
                <button
                  onClick={() => setLanguage('de')}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
                    language === 'de'
                      ? 'bg-primary text-white'
                      : 'text-babyblue-600 hover:text-babyblue-800'
                  }`}
                  data-testid="disclaimer-lang-de"
                >
                  Deutsch
                </button>
                <button
                  onClick={() => setLanguage('en')}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
                    language === 'en'
                      ? 'bg-primary text-white'
                      : 'text-babyblue-600 hover:text-babyblue-800'
                  }`}
                  data-testid="disclaimer-lang-en"
                >
                  English
                </button>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-md border border-babyblue-200 p-8 md:p-10 leading-relaxed text-babyblue-800">
            {language === 'en' ? (
              <div className="space-y-5">
                <p>
                  Germanatic is for <strong>educational and informational purposes</strong> only. We
                  encourage everybody to inform themselves separately, as things can vary from
                  institution and federal state (Bundesland).
                </p>
                <p>
                  Some information may not be complete, and we suggest carrying out further research
                  for your specific situation. We are <strong>not liable</strong> for the actions of
                  our users based on the information provided here.
                </p>
                <p className="bg-amber-50 border-l-4 border-amber-400 text-amber-900 p-4 rounded">
                  All information provided is without warranty —{' '}
                  <em>Alle Angaben sind ohne Gewähr.</em>
                </p>
              </div>
            ) : (
              <div className="space-y-5">
                <p>
                  Germanatic dient ausschließlich <strong>Bildungs- und Informationszwecken</strong>.
                  Wir empfehlen allen Nutzern, sich zusätzlich eigenständig zu informieren, da
                  Informationen je nach Institution und Bundesland variieren können.
                </p>
                <p>
                  Einige Informationen sind möglicherweise unvollständig; weitere Recherche zu Ihrem
                  konkreten Anliegen wird empfohlen. Für Handlungen unserer Nutzerinnen und Nutzer
                  auf Grundlage der hier bereitgestellten Inhalte übernehmen wir{' '}
                  <strong>keine Haftung</strong>.
                </p>
                <p className="bg-amber-50 border-l-4 border-amber-400 text-amber-900 p-4 rounded">
                  <strong>Alle Angaben sind ohne Gewähr.</strong>
                </p>
              </div>
            )}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default DisclaimerPage;
